var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridViewAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 7,
    fill: "#E0E3E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 13C16.1022 13 15.7206 12.842 15.4393 12.5607C15.158 12.2794 15 11.8978 15 11.5C15 11.1022 15.158 10.7206 15.4393 10.4393C15.7206 10.158 16.1022 10 16.5 10C16.8978 10 17.2794 10.158 17.5607 10.4393C17.842 10.7206 18 11.1022 18 11.5C18 11.8978 17.842 12.2794 17.5607 12.5607C17.2794 12.842 16.8978 13 16.5 13ZM7.5 13C7.10217 13 6.72064 12.842 6.43934 12.5607C6.15803 12.2794 6 11.8978 6 11.5C6 11.1022 6.15803 10.7206 6.43934 10.4393C6.72064 10.158 7.10218 10 7.5 10C7.89782 10 8.27936 10.158 8.56066 10.4393C8.84196 10.7206 9 11.1022 9 11.5C9 11.8978 8.84196 12.2794 8.56066 12.5607C8.27936 12.842 7.89782 13 7.5 13ZM11.8644 13C11.4666 13 11.085 12.842 10.8037 12.5607C10.5224 12.2794 10.3644 11.8978 10.3644 11.5C10.3644 11.1022 10.5224 10.7206 10.8037 10.4393C11.085 10.158 11.4666 10 11.8644 10C12.2622 10 12.6438 10.158 12.9251 10.4393C13.2064 10.7206 13.3644 11.1022 13.3644 11.5C13.3644 11.8978 13.2064 12.2794 12.9251 12.5607C12.6438 12.842 12.2622 13 11.8644 13Z",
    fill: "#99A1B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridViewAction);
export default __webpack_public_path__ + "static/media/grid-view-action.5b1aae5770bee7c64280f3bf817e714c.svg";
export { ForwardRef as ReactComponent };